import script from "./StatusWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusWindow.vue?vue&type=script&setup=true&lang=js"

import "./StatusWindow.vue?vue&type=style&index=0&id=446419d7&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446419d7"]])

export default __exports__